import { render, staticRenderFns } from "./ListCaixas.vue?vue&type=template&id=3a803876"
import script from "./ListCaixas.vue?vue&type=script&lang=js"
export * from "./ListCaixas.vue?vue&type=script&lang=js"
import style0 from "./ListCaixas.vue?vue&type=style&index=0&id=3a803876&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports